/** */
import { combineReducers } from 'redux';

import announcements from './reducers/announcement';
import audiences from './reducers/audience';
import payments from './reducers/payment';
import blogs from './reducers/blog';
import currency from './reducers/currency';
import demos from './reducers/demo';
import effects from './reducers/effect';
import events from './reducers/event';
import contacts from './reducers/contact';
import content_jobs from './reducers/content-job';
import campaigns from './reducers/campaign';
import header from './reducers/header';
import lead from './reducers/lead';
import metadata from './reducers/metadata';
import mobi_push from './reducers/push/mobile';
import permissions from './reducers/permission';
import plans from './reducers/plan';
import processes from './reducers/process';
import resources from './reducers/resource';
import referrals from './reducers/referral';
import roles from './reducers/role';
import servers from './reducers/server';
import settings from './reducers/settings';
import sms from './reducers/sms';
import tenants from './reducers/tenant';
import transactionals from './reducers/transactional';
import tutorials from './reducers/tutorial';
import users from './reducers/user';
import user_data from './reducers/user-data';
import walletlogs from './reducers/wallet-log';
import word_searches from './reducers/word-search';
import { LOGOUT } from './actions/user-data';

const appReducer = combineReducers({
  announcements,
  audiences,
  payments,
  blogs,
  currency,
  demos,
  effects,
  events,
  contacts,
  content_jobs,
  campaigns,
  header,
  lead,
  metadata,
  mobi_push,
  permissions,
  plans,
  processes,
  resources,
  referrals,
  roles,
  servers,
  settings,
  sms,
  tenants,
  transactionals,
  tutorials,
  users,
  user_data,
  walletlogs,
  word_searches
});

const rootReducer = (state, action) => {
  // when a logout action is dispatched it will reset redux state
  if (action.type === LOGOUT) {
    state = undefined;
  }

  return appReducer(state, action);
};

export default rootReducer;
